import React, { useEffect, useState } from 'react'
import {
  ONGOING_EVENT,
  ONGOING_EVENT_COLOR,
  NOT_ONGOING_EVENT_COLOR,
  COMPLETED,
  CANCELLED,
  COMPLETED_EVENT_COLOR,
  CANCELLED_EVENT_COLOR,
  FAILED_EVENT_COLOR,
  DELETED_EVENT_COLOR,
  FAILED,
  DELETED,
  STOPPED,
  SCHEDULING,
  SCHEDULINGCOLOR,
  OPTEDOUT,
  OPTEDOUTCOLOR
} from './constants'
import _ from 'lodash'
import {
  Link,
  Grid,
  Box,
  Typography,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Popover,
  IconButton,
  TextField,
  CircularProgress
} from '@material-ui/core'
import Pagination from '@material-ui/lab/Pagination'
import { useStyles } from './styles'
import { ArrowUpward, ArrowDownward, InfoOutlined } from '@material-ui/icons'
import { SORTORDER } from '../../utils/constants'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import DraftsIcon from '@material-ui/icons/Drafts'
import FilterListIcon from '@material-ui/icons/FilterList'
import OutlinedButton from '../outlinedButton'

export default function TableOutline(props) {
  const classes = useStyles()
  const { tableData, tableHeadings, page, rowsPerPage, totalElement, loading = false, isRegisteredSitesManagement = false, newSiteId, setNewSiteId, handleSiteAddition, isSuperAdmin, addingSite = false } = props
  const [startIndex, setStartIndex] = useState(0)
  const [endIndex, setEndIndex] = useState(0)
  const [totalPageCount, setTotalPageCount] = useState(0)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [infoAnchorEl, setInfoAnchorEl] = useState(null)
  const [infoId, setInfoId] = useState()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleInfoClick = (event, id) => {
    setInfoAnchorEl(event.currentTarget)
    setInfoId(id)
  }

  const handleInfoClose = () => {
    setInfoAnchorEl(null)
    setInfoId(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'dropsown-popover' : undefined

  const hasLink = (id) => {
    return tableHeadings.some((obj) => {
      return obj.id === id && obj.isLink
    })
  }

  const hasActive = (id) => {
    return tableHeadings.some((obj) => obj.id === id && obj.isActive === true)
  }

  useEffect(() => {
    const startPoint = (page - 1) * rowsPerPage + 1
    let endPoint = startPoint + rowsPerPage - 1
    endPoint = endPoint > totalElement ? totalElement : endPoint
    const pageCount = Math.ceil(totalElement / rowsPerPage)
    setStartIndex(totalElement === 0 ? 0 : startPoint)
    setEndIndex(endPoint)
    setTotalPageCount(pageCount)
  }, [rowsPerPage, totalElement, page])

  const getColor = (status) => {
    switch (status) {
      case ONGOING_EVENT:
        return ONGOING_EVENT_COLOR
      case STOPPED:
      case COMPLETED:
        return COMPLETED_EVENT_COLOR
      case CANCELLED:
        return CANCELLED_EVENT_COLOR
      case FAILED:
        return FAILED_EVENT_COLOR
      case DELETED:
        return DELETED_EVENT_COLOR
      case SCHEDULING:
        return SCHEDULINGCOLOR
      case OPTEDOUT:
        return OPTEDOUTCOLOR
      default:
        return NOT_ONGOING_EVENT_COLOR
    }
  }

  return (
    <Grid className={classes.spacing} container>
      <TableContainer className={classes.table} component={Paper}>
        <Table stickyHeader size={props.small ? 'small' : 'medium'}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              {tableHeadings.map((obj, index) => {
                return (
                  <TableCell key={index} className={`${classes.tableHeader} ${obj.className ? obj.className : ''}`}>
                    {obj.isDropdown ?
                      <>
                        <Button
                          className={`${classes.headerWrapper} ${classes.tableHeading}`}
                          aria-describedby={id}
                          variant="contained"
                          disableElevation
                          disableRipple
                          disableFocusRipple
                          style={{ backgroundColor: 'transparent' }}
                          onClick={handleClick}
                          endIcon={<FilterListIcon />}
                        >
                          {obj.header}
                        </Button>
                        <Popover
                          id={id}
                          open={open}
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                          }}
                          PaperProps={{
                            className: classes.popoverPaper,
                          }}
                        >
                          {obj.dropDownValues.map((value, index) => (
                            <Box className={`${classes.dropDownValues} ${value === props.selectedStatus ? classes.active : ''}`} key={index} p={1.5} onClick={() => { props.handleDropdownChange(value); handleClose() }}>{value}</Box>
                          ))}
                        </Popover>
                      </> :
                      obj.isPopover ?
                        <>
                          <Button
                            className={`${classes.headerWrapper} ${classes.tableHeading}`}
                            aria-describedby={id}
                            variant="contained"
                            disableElevation
                            disableRipple
                            disableFocusRipple
                            style={{ backgroundColor: 'transparent', cursor: 'default' }}
                            endIcon={<InfoOutlined className={classes.infoIcon} onClick={(e) => handleInfoClick(e, obj.id)} />}
                          >
                            {obj.header}
                          </Button>
                          <Popover
                            id={infoId}
                            open={infoId === obj.id}
                            anchorEl={infoAnchorEl}
                            onClose={handleInfoClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left',
                            }}
                            PaperProps={{
                              className: classes.infoPopoverPaper,
                            }}
                          >
                            <Box className={classes.infoPopover} p={1.5}>
                              {obj.popoverContent}
                            </Box>
                          </Popover>
                        </> :
                        <IconButton
                          size="small"
                          className={`${classes.headerWrapper} ${obj.isSortable ? '' : classes.noPointer} ${classes.tableHeading}`}
                          disableRipple={true}
                          onClick={() => obj.isSortable && props.handleSortData(obj)}
                        >
                          {_.get(obj, 'header', '')}
                          {obj.isSortable &&
                            (obj.sortOrder === SORTORDER.ASC ? (
                              <ArrowUpward
                                fontSize="small"
                                className={classes.sortIcon}
                              />
                            ) : (
                              <ArrowDownward
                                fontSize="small"
                                className={classes.sortIcon}
                              />
                            ))}
                        </IconButton>
                    }
                  </TableCell>
                )
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading || tableData.length > 0 ?
              tableData.map((row, index) => {
                const uniqueKey = row.find(col => col.id === 'siteId')?.value || index
                return (
                <TableRow key={uniqueKey}>
                  {row.map((obj, index) => {
                    return (
                      <TableCell key={index} className={obj.className}>
                        {hasLink(obj.id) ? (
                          hasActive(obj.id) ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'centre',
                              }}
                            >
                              <FiberManualRecordIcon
                                htmlColor={getColor(obj.statusValue)}
                                fontSize="small"
                              ></FiberManualRecordIcon>
                              <Link
                                component="button"
                                variant="body2"
                                onClick={() => obj.handleClick(obj)}
                                style={{ color: '#3B86FF', paddingLeft: '0.4em', textAlign: 'left' }}
                              >
                                {_.get(obj, 'value', '')}
                              </Link>
                            </div>
                          ) : (
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => obj.handleClick(obj)}
                              style={{ color: '#3B86FF', textAlign: 'left' }}
                            >
                              {_.get(obj, 'value', '')}
                            </Link>
                          )
                        ) : (
                          <Typography>{_.get(obj, 'value', '')}</Typography>
                        )}
                      </TableCell>
                    )
                  })}
                </TableRow>
                )
              }) :
              <TableRow>
                <TableCell colSpan={tableHeadings.length}>
                  <Box display="flex" justifyContent="center" alignItems="center" minHeight="150px" flexDirection="column">
                    <DraftsIcon fontSize="large" color="disabled" />
                    No Data Found
                  </Box>
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {props.pagination && (
        <Box className={classes.paginationWrapper}>
          <Box className={isRegisteredSitesManagement ? classes.rowsWrapper : ''} >
            <Box className={classes.paginationSelectWrapper}>
              <Typography>Rows per page</Typography>
              <Select
                value={rowsPerPage}
                onChange={(event) =>
                  props.handleChangeRowsPerPage(event.target.value)
                }
                classes={{ root: classes.selectRoot }}
                className={classes.selectWrapper}
              >
                {props.rowsPerPageOptions.map((value) => {
                  return <MenuItem value={value}>{value}</MenuItem>
                })}
              </Select>
              <Typography>{`${startIndex}-${endIndex} of ${totalElement}`}</Typography>
            </Box>
            {isRegisteredSitesManagement && isSuperAdmin &&
              <Box className={classes.addSiteWrapper} >
                <TextField
                  size="small"
                  variant="outlined"
                  value={newSiteId}
                  onChange={(e) => setNewSiteId(e.target.value)}
                  inputProps={{ style: { padding: '6px 8px' } }}
                  placeholder="Enter Site ID"
                  disabled={addingSite}
                />
                <Box style={{ position: 'relative', display: 'inline-block' }}>
                  <OutlinedButton
                    height='31px'
                    label='ADD'
                    onClick={() => !addingSite && handleSiteAddition()}
                    disabled={addingSite}
                  ></OutlinedButton>
                  {addingSite && <CircularProgress className={classes.addingSiteLoader} size={20}/> }
                </Box>
              </Box>
            }
          </Box>
          <Pagination
            page={page}
            count={totalPageCount}
            shape="rounded"
            onChange={(event, newPage) => { page !== newPage && props.handleChangePage(newPage) }}
          />
        </Box>
      )}
    </Grid>
  )
}

TableOutline.defaultProps = {
  tableData: [],
  tableHeadings: [],
  pagination: false,
  rowsPerPage: 10,
  page: 1,
  totalElement: 0,
  rowsPerPageOptions: [10, 25, 100],
  handleChangePage: () => { },
  handleChangeRowsPerPage: () => { },
  handleSortData: () => { },
}
